import { useToggle } from "client/hooks/utils/useToggle";
import { useState } from "react";
import { ColorChangeHandler } from "react-color";
import { setSettings } from "store/features/memeGenerator/actions";
import { MAX_SHADOW_SIZE } from "store/features/memeGenerator/data/configs";
import { TextBox } from "store/features/memeGenerator/types";
import { useAppDispatch } from "store/store";

export const useShadow = (textBox: TextBox) => {
    const dispatch = useAppDispatch();
    const { isOpen, onClose: close, toggle } = useToggle(false);
    function handleShadowBlurRadiusChange(value: number) {
        const shadow = textBox.shadow;
        if (!shadow) throw new Error("Outline width accessed without shadow activated");
        if (value < 0 || value > MAX_SHADOW_SIZE || isNaN(value))
            throw new Error(`Invalid shadow blur radius: ${value}`);
        dispatch(
            setSettings({
                id: textBox.id,
                shadow: {
                    ...shadow,
                    blurRadius: value,
                },
            }),
        );
    }
    const handleColorChange: ColorChangeHandler = (color) => {
        if (!textBox.shadow?.isActive) throw new Error("Shadow not activated");
        setShadowColor(color.hex);
    };

    const setShadowColor = (color: string) => {
        if (!textBox.shadow) return;
        dispatch(
            setSettings({
                id: textBox.id,
                shadow: {
                    ...textBox.shadow,
                    color: color,
                },
            }),
        );
    };
    const [bottomModalColorValue, setBottomModalColorValue] = useState("");
    const onApprove = (color: string) => {
        close();
        setShadowColor(color);
    };

    return {
        handleShadowBlurRadiusChange,
        isOpen,
        close,
        toggle,
        handleColorChange,
        setShadowColor,
        bottomModalColorValue,
        setBottomModalColorValue,
        onApprove,
    };
};
